import React, { FC } from 'react'
import { Spinner } from 'react-bootstrap'
import { useParams } from 'react-router'
import { userTypes } from 'shared'
import { useUserRole } from 'auth'

import { PageTitle } from '../../../../_metronic/layout/core'
import { CampaignHeader } from '../../components/partials/CampaignHeader'
import { useCampaign } from '../../hooks'

// TODO: this is not a page, it is a container that gets campaignId from the route for some reason.
//   - rename to CampaignContainer
//   - take campaignId as a prop
export const CampaignPage: FC = ({ children }) => {
  const params: any = useParams()
  const role = useUserRole()
  const campaignId = Number(params?.id)
  const { status, data: campaign, error, isFetching } = useCampaign(campaignId)
  const profileBreadCrumbs: Array<any> = [
    {
      title: 'Home',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    role !== userTypes.CampaignUser && {
      title: 'Client',
      path: `/client/view/${campaign?.client?.id}`,
      isSeparator: false,
      isActive: false,
    },
    role !== userTypes.CampaignUser && {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ].filter(Boolean)

  return (
    <>
      {isFetching ? (
        <div className='d-flex align-items-center justify-content-center'>
          <Spinner animation='grow'></Spinner>
        </div>
      ) : status === 'error' ? (
        <span>Error: {(error as any).message}</span>
      ) : (
        <>
          <PageTitle breadcrumbs={profileBreadCrumbs}>Campaign Overview</PageTitle>
          <CampaignHeader campaign={campaign} />
          {children}
        </>
      )}
    </>
  )
}
